import React from 'react'
import { ContentBlock } from 'components/ContentBlock'
import CashRegisterTree from 'components/CashRegisterTree'

const CashRegisters = ({ data, mutations: { updateItem } }) => (
	<ContentBlock>
		<CashRegisterTree
			activeNodesArr={data.cashRegisterId}
			onChange={cashRegisterId => updateItem({ cashRegisterId })}
			withContext
		/>
	</ContentBlock>
)

export default CashRegisters
